// @ts-nocheck
import { BarChart2 } from 'lucide-react'
import SentimentAnalysisChart from '@/components/reports/SentimentAnalysisChart'
import SentimentAnalysisPieChart from '@/components/reports/SentimentAnalysisPieChart'
import ClassificationReport from '@/components/reports/ClassificationReport'
import AudienceProfileReport from '@/components/reports/AudienceProfileReport'
import ExtractionReport from '@/components/reports/ExtractionReport'
import SummarisationReport from '@/components/reports/SummarisationReport'

const Reports = () => {
    return (
        <div className="card page-card">
            <div className="card-header page-card-header">
                <div className="header-title">
                    <h5 className="title mb-0 text-white d-flex align-items-center">
                        <i className="icon text-gray-200 me-2">
                            <BarChart2 size={24} />
                        </i>
                        AI Reports
                    </h5>
                </div>
            </div>
            <div className="card-body page-card-body">
                <div className="row">
                    <SentimentAnalysisChart name="Sentiment Analysis" />
                    <SentimentAnalysisPieChart name="Generative AI Sentiment" />
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <AudienceProfileReport />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <ClassificationReport />
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <ExtractionReport />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <SummarisationReport />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reports
